<template>
  <div class="sidebar-items-wrapper">
    <div class="flex flex-col justify-between">
      <ul class="sidenav-items overflow-y-auto" style="height: calc(100vh - 10rem)">
        <sidebar-item title="Dashboard" url="/dashboard">
          <template v-slot:icon>
            <home-svg />
          </template>
        </sidebar-item>
        <sidebar-item title="Locations" url="/user/locations">
          <template v-slot:icon>
            <location-svg />
          </template>
        </sidebar-item>
        <sidebar-item-dropdown title="Booking & Shipments">
          <template v-slot:icon>
            <operations-svg />
          </template>
          <template v-slot:children>
            <router-link
              class="flex items-center"
              :to="{ name: 'ActiveBookings' }"
            >
            <DropDownLink title="Active Bookings">
              <img src="@/assets/images/ondemand/active-booking.svg" />
          </DropDownLink>
              </router-link
            >

            <router-link
              class="flex items-center"
              :to="{ name: 'QuoteAndDraft' }"
            >
            <DropDownLink title="Quotes & Drafts">
              <img src="@/assets/images/ondemand/quotes-draft.svg" />
            </DropDownLink>
              </router-link
            >
            <!-- <router-link :to="{ name: 'BookingHome3pl' }"
            >Shipping (Admin)</router-link
          > -->
            <router-link
              class="flex items-center"
              :to="{ name: 'HistoricalBookings' }"
              >
              <DropDownLink title=" Shipping History">
                <img src="@/assets/images/ondemand/shippin-history.svg" />
              </DropDownLink>
             </router-link
            >
          </template>
        </sidebar-item-dropdown>
        <sidebar-item-dropdown title="Billings & Payments">
          <template v-slot:icon>
            <payments-svg />
          </template>
          <template v-slot:children>
            <router-link
              class="flex items-center"
              :to="{ name: 'PaymentsTransaction' }"
            >
            <DropDownLink title="My Transactions">
                <img src="@/assets/images/ondemand/transactions.svg" />
            </DropDownLink>
              </router-link
            >

            <router-link
              v-if="$store.state.authentication.env == 'development'"
              class="flex items-center"
              :to="{ name: 'AccountStatement', params: { name: 'account' } }"
            >
            <DropDownLink title=" Account Statements">
              <img src="@/assets/images/ondemand/acount-statement.svg" />
          </DropDownLink>
           </router-link
            >
          </template>
        </sidebar-item-dropdown>
        <sidebar-item v-if="$_isDevelopment" title="Ratings" url="/user/rating">
          <template v-slot:icon>
            <RatingsLogo />
          </template>
        </sidebar-item>
        <sidebar-item title="Analytics" url="/user/analytic">
          <template v-slot:icon>
            <AnalyticLogo />
          </template>
        </sidebar-item>
      </ul>
      <ul class="justify-self-end">
        <div
          class="flex items-center pl-8 cursor-pointer logout"
          @click="logout"
        >
          <div class="mr-3 flex items-center">
            <span class="sidebar-item__icon inline-block">
              <img src="@/assets/images/icons/logout.svg" alt="logout icon" />
            </span>
          </div>
          <div class="text-white"
          :class="[ isSideNavCollapsed ? 'hidden' : 'inline-block']"
          >
            <p class="text-sm">Logout</p>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem";
import SidebarItemDropdown from "./SidebarItemDropdown";
import DropDownLink from "./DropDownLink.vue";
// import MuleexLogo from "./svgs/MuleexLogo";
import HomeSvg from "./svgs/HomeSvg";
import LocationSvg from "./svgs/LocationSvg";
import PaymentsSvg from "./svgs/PaymentsSvg";
import OperationsSvg from "./svgs/OperationsSvg";
import AnalyticLogo from "./svgs/AnalyticLogo.vue";

import RatingsLogo from "./svgs/RatingsLogo.vue";

export default {
  components: {
    SidebarItem,
    SidebarItemDropdown,
    // MuleexLogo,
    DropDownLink,
    AnalyticLogo,
    HomeSvg,
    PaymentsSvg,
    LocationSvg,
    OperationsSvg,
    RatingsLogo,
  },
  data() {
    return {
      showTerminalChildren: false,
    };
  },
  computed: {
    disabled() {
      return this.$store.state.authentication.env == "staging" ? true : false;
    },
    isSideNavCollapsed() {
      return this.$store.getters.isSideNavCollapsed;
    },
  },
  methods: {
    async logout() {
      try {
        // await this.$_logout();
        localStorage.clear();
        // localStorage.clear();
        this.$router.push({ name: "Login" });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidenav-items {
  margin-top: 3rem;
}

.muleex-logo {
  padding-top: 1.5rem;
  padding-left: 3rem;
}
svg {
  display: inline-block;
}
</style>
